/* eslint-disable write-good-comments/write-good-comments -- rule names contain "only" which triggers false positives in oxlint directives */
"use client";

import { useEffect, useState } from "react";

import { consoleOutput, createLogger } from "@vllnt/logger";
import type { ComponentType } from "react";

const logger = createLogger("app-loader", {
  getLogLevel: () => "info",
  output: consoleOutput,
});

type AppLoaderProperties = {
  appId: string;
};

const SAFE_ID_PATTERN = /^[\da-z-]+$/;

export function AppLoader({ appId }: AppLoaderProperties) {
  // oxlint-disable-next-line react-doctor/rerender-state-only-in-handlers -- loadedApp value drives JSX
  const [loadedApp, setLoadedApp] = useState<ComponentType | undefined>();
  // oxlint-disable-next-line react-doctor/rerender-state-only-in-handlers -- loadError value drives JSX
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    if (!SAFE_ID_PATTERN.test(appId)) return;
    // oxlint-disable-next-line react-doctor/no-dynamic-import-path -- appId validated by SAFE_ID_PATTERN; per-app dynamic chunk required
    import(`@/content/apps/${appId}/app`)
      .then((loaded: { default?: ComponentType }) => {
        if (loaded.default) {
          setLoadedApp(() => loaded.default);
        }
      })
      .catch((error: unknown) => {
        logger.error("Failed to load app", { appId, error });
        setLoadError(true);
      });
  }, [appId]);

  if (loadError) {
    return (
      <div className="flex items-center justify-center w-full h-screen bg-background text-foreground">
        <p>Failed to load application.</p>
      </div>
    );
  }

  if (!loadedApp) {
    return (
      <div className="flex items-center justify-center w-full h-screen bg-background">
        <div className="animate-pulse text-muted-foreground text-lg">
          Loading…
        </div>
      </div>
    );
  }

  const AppComponent = loadedApp;
  return <AppComponent />;
}
